import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import "./about.css";
import AboutPagecover from './aboutus.png';
import CoverImage from './coverimg.png';
import AboutProfile from './aboutprofile.jpeg';
import MissionImage from './mission.png';
import { loadFromLocalStorage } from "utils/LocalStorageUtils";

function About() {
  const navigate = useNavigate();

  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  return (
    <Fragment>
      <section className="services-section">
        <div className="container text-center">
          <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
            {languageData?.aboutUs}
          </h3>
          <br />
          <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
            {languageData?.atMyDigitalIndiaWeAreCommittedToProviding}
          </p>
          <div style={{ textAlign: 'center' }} className="my-5">
            <img src={AboutPagecover} alt="coverimg" />
          </div>
        </div>
      </section>
      <section className="text-center-sm">
        <div className="container">
          <div className="row" style={{ alignItems: 'center' }}>
            <div className="col-lg-6">
              <div className="text-center">
                <img src={CoverImage} width={'60%'} alt="profile" />
              </div>
            </div>
            <div className="col-lg-6">
              <h2>{languageData?.whoWeAre}</h2> <br />
              <p style={{ fontSize: 17, fontWeight: 400, width: '100%' }}>
                {languageData?.foundedByDedicatedTeamOfTechEnthusiasts}
              </p>
              <br />
              <span style={{
                display: 'block', border: '1px solid #ff671f', margin: '0 auto' // Centers horizontally
              }}></span>
            </div>
          </div>
        </div>
      </section>
      <section className="text-center-sm">
        <div className="container">
          <div className="row" style={{ alignItems: 'center' }}>
            <div className="col-lg-6">
              <h2>{languageData?.meetOurFounder}</h2> <br />
              <p style={{ fontSize: 17, fontWeight: 400, width: '100%' }}>
                {languageData?.mrsKhushbuBhatiTheVisionary}
              </p>
              <br />
              <span style={{ display: 'block', border: '1px solid #ff671f' }}></span>
            </div>
            <div className="col-lg-6">
              <div className="text-center form-margin-cst">
                <img src={AboutProfile} width={'45%'} alt="profile" style={{ borderRadius: 10, marginBottom: 10 }} />
                <h5 className="m-0">{languageData?.khushbuBhati}</h5>
                <p className="m-0" style={{ color: '#ff671f' }}>{languageData?.founder}</p>
                <p>MAXCODE IT SOLUTIONS PVT. LTD.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="text-center-sm">
        <div className="container">
          <div className="row" style={{ alignItems: 'center', background: '#FFB596', borderRadius: 30, padding: '1rem' }}>
            <div className="col-lg-6">
              <h2>{languageData?.ourVision}</h2> <br />
              <p style={{ fontSize: 17, fontWeight: 400, width: '100%' }}>
                {languageData?.ourVisionIsDigitallyEmpowered}
              </p>
            </div>
            <div className="col-lg-6">
              <div className="text-center">
                <img src={MissionImage} width={'45%'} alt="profile" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="text-center-sm">
        <div className="container">
          <div className="row" style={{ alignItems: 'center' }}>
            <div className="col-lg-9">
              <h2>{languageData?.joinUs}</h2> <br />
              <p style={{ fontSize: 17, fontWeight: 400, width: '100%' }}>{languageData?.becomePartofTheMyDigitalIndiaCommunity}</p>
            </div>
            <div className="col-lg-3 text-center">
              <br />
              <Link to='/signup' style={{ color: 'inherit' }}>
              <button style={{ marginTop: 20, marginBottom: 20 }}
                // onClick={() => {
                //   navigate(isAuth ? "/categories" : "/login");
                // }}
                className="btn play-btn"
              >
                {languageData?.signUp}<i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
              </button>{" "}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default About;